var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGraphicsCard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 96,
    viewBox: "0 0 96 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.00209 21.9364C8.34648 21.2459 8.90376 20.9902 9.70316 21.0003C12.1494 21.0345 14.5977 21.0083 17.0459 21.0144C18.2023 21.0184 18.6468 21.4472 18.651 22.5646C18.6594 24.1429 18.6531 25.7193 18.6531 27.3742C19.0705 27.3923 19.4212 27.4225 19.7739 27.4225C39.642 27.4245 59.5101 27.4325 79.3761 27.4164C82.5988 27.4144 85.1452 28.5438 86.865 31.2214C87.5914 32.3529 87.9775 33.6071 87.9796 34.9358C87.9921 42.7975 88.0234 50.6591 87.9692 58.5187C87.942 62.4868 84.6234 65.7482 80.5262 65.9576C79.0505 66.0321 77.5686 65.9697 76.022 65.9697C76.0053 66.3401 75.9824 66.6059 75.9824 66.8716C75.9803 69.0318 75.9823 71.192 75.9803 73.3522C75.9782 74.5762 75.5545 74.995 74.3126 74.997C70.9793 75.001 67.6461 75.001 64.3128 74.997C63.1147 74.997 62.6743 74.5661 62.6702 73.4005C62.666 71.2403 62.6702 69.0801 62.6702 66.9199C62.6702 66.6481 62.6702 66.3764 62.6702 66.0522H57.3415C57.3415 66.3643 57.3415 66.6361 57.3415 66.9078C57.3415 69.0922 57.3499 71.2786 57.3373 73.4629C57.3311 74.5259 56.8469 74.993 55.7657 74.993C46.1311 74.997 36.4966 74.997 26.8621 74.993C25.8164 74.993 25.3426 74.5239 25.3384 73.5092C25.3301 71.049 25.3363 68.5889 25.3363 66.0663H18.651C18.651 68.0876 18.651 70.0666 18.651 72.0476C18.651 72.5992 18.6677 73.1529 18.6427 73.7045C18.6072 74.4977 18.0791 74.997 17.3194 74.9909C16.5784 74.9869 16.019 74.4756 16.0003 73.6844C15.9669 72.3033 15.9877 70.9222 15.9877 69.5411C15.9877 69.2472 15.9877 68.9533 15.9877 68.5849C14.7291 68.5849 13.5624 68.5909 12.3977 68.5849C11.1078 68.5748 10.6654 68.144 10.6633 66.8998C10.6591 63.735 10.6591 60.5702 10.6633 57.4054C10.6633 56.1613 11.1183 55.7183 12.3957 55.7123C13.5624 55.7063 14.7271 55.7123 15.9397 55.7123V53.1434C14.846 53.1434 13.7398 53.1434 12.6315 53.1434C11.2999 53.1434 10.6528 52.7146 10.6674 51.8469C10.6821 50.9913 11.3333 50.5766 12.6712 50.5766C13.7356 50.5766 14.8022 50.5766 15.9272 50.5766V48.0097C14.7458 48.0097 13.5561 48.0137 12.3685 48.0097C11.1308 48.0057 10.6654 47.5648 10.6654 46.375C10.6612 43.186 10.6612 39.9951 10.6654 36.8061C10.6654 35.6002 11.1078 35.1734 12.3497 35.1653C13.5186 35.1593 14.6874 35.1653 15.9209 35.1653V32.5904C14.8606 32.5904 13.8024 32.5944 12.7442 32.5884C12.4082 32.5864 12.0638 32.5904 11.7361 32.528C11.0682 32.3992 10.6361 31.8516 10.6695 31.2335C10.7029 30.6074 11.1705 30.086 11.8592 30.0497C12.8715 29.9974 13.888 30.0215 14.9045 30.0155C15.2363 30.0135 15.5703 30.0155 15.946 30.0155V23.5812C15.4179 23.5812 14.8836 23.5812 14.3472 23.5812C12.8361 23.5812 11.3249 23.551 9.81587 23.5933C9.00395 23.6155 8.40492 23.3658 8 22.6894V21.9364H8.00209ZM35.9623 32.5884C27.9766 32.5401 21.3957 38.9079 21.3226 46.7555C21.2517 54.3957 27.8994 60.7957 35.956 60.8501C43.9897 60.9024 50.6019 54.5648 50.6562 46.7615C50.7105 38.9764 44.1358 32.6367 35.9623 32.5884ZM67.955 32.5884C59.9568 32.5542 53.3612 38.9421 53.3237 46.7615C53.2861 54.4681 59.9192 60.8199 68.0384 60.8521C76.0408 60.8823 82.6322 54.5003 82.6677 46.685C82.7011 38.9723 76.0763 32.6267 67.955 32.5904V32.5884ZM28.0539 66.0522V72.3979H32.0091C32.0091 71.6208 32.0008 70.8759 32.0112 70.129C32.0258 69.1506 32.5059 68.603 33.3282 68.601C34.1527 68.601 34.6557 69.1526 34.6745 70.1169C34.6891 70.8618 34.6766 71.6087 34.6766 72.3717H37.344C37.344 71.9208 37.344 71.5222 37.344 71.1235C37.344 70.6967 37.3273 70.2679 37.3544 69.8431C37.4045 69.0399 38.0015 68.5365 38.7967 68.605C39.5272 68.6674 39.9843 69.1828 40.0052 70.0183C40.0261 70.8095 40.0094 71.6007 40.0094 72.3838H42.6747C42.6747 71.6208 42.6706 70.8981 42.6747 70.1753C42.681 69.1586 43.1715 68.5849 44.0189 68.5969C44.86 68.609 45.3297 69.1788 45.3359 70.2115C45.3401 70.9303 45.3359 71.651 45.3359 72.3717H47.9971C47.9971 71.5664 47.9888 70.8175 47.9992 70.0666C48.0117 69.1606 48.5085 68.611 49.3058 68.5969C50.1386 68.5829 50.6458 69.1385 50.6583 70.0928C50.6666 70.8598 50.6583 71.6268 50.6583 72.3878H54.6198V66.0462H28.0518L28.0539 66.0522ZM65.396 66.0623V72.3939H67.884C67.9383 72.3375 67.9717 72.3194 67.9717 72.3013C67.9821 71.5503 67.9842 70.7974 68.0009 70.0465C68.0197 69.1526 68.531 68.601 69.3304 68.601C70.1319 68.601 70.6433 69.1466 70.6579 70.0424C70.6704 70.8135 70.66 71.5846 70.66 72.3838H73.2919V66.0623H65.396ZM15.9397 45.4187V37.7926H13.3913V45.4187H15.9397ZM13.3725 65.9455H15.9293V58.3255H13.3725V65.9455Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M40.9361 36.1981C42.6706 36.9631 44.021 37.9698 45.1481 39.2663C45.2378 39.369 45.2963 39.5441 45.2796 39.675C45.0166 41.8794 43.4428 44.3396 41.3953 45.1429C41.3264 45.1691 41.2471 45.1711 41.1239 45.1952C40.7649 44.547 40.4978 44.0135 40.9465 43.178C42.0047 41.209 41.8419 39.1072 41.2137 37.0256C41.1427 36.794 41.0592 36.5645 40.9361 36.1961V36.1981Z",
    fill: "url(#paint0_linear_2_1703)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M47.1977 42.6485C47.8719 44.3537 48.0848 45.9502 47.9574 47.593C47.9449 47.748 47.8385 47.9332 47.7153 48.0359C46.1311 49.3445 42.8647 50.2786 40.7462 49.1351C40.9257 48.4003 41.197 47.8708 42.1049 47.589C44.2422 46.9246 45.649 45.3764 46.726 43.5343C46.8658 43.2948 46.9869 43.0471 47.1956 42.6505L47.1977 42.6485Z",
    fill: "url(#paint1_linear_2_1703)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M24.7916 50.7698C24.1425 49.1009 23.8899 47.4923 24.0611 45.8254C24.0757 45.6885 24.1383 45.5194 24.2406 45.4348C25.8373 44.092 29.1538 43.1599 31.2452 44.3074C31.0908 45.1006 30.7171 45.5878 29.8176 45.8797C27.6949 46.5682 26.3006 48.1184 25.2361 49.9646C25.1005 50.2001 24.9732 50.4397 24.7916 50.7698Z",
    fill: "url(#paint2_linear_2_1703)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M25.0733 41.9982C25.8665 40.2971 26.9226 38.9945 28.2647 37.9013C28.3711 37.8148 28.5444 37.7745 28.6863 37.7684C30.7318 37.704 33.7123 39.7636 34.424 41.7526C33.7645 42.1452 33.2051 42.3747 32.341 41.9459C30.02 40.8004 27.6176 41.0822 25.0713 41.9962L25.0733 41.9982Z",
    fill: "url(#paint3_linear_2_1703)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M33.4326 51.2913C34.3384 51.4704 34.8227 51.8328 35.1149 52.6723C35.7786 54.5789 37.2396 55.8955 39.0117 56.9021C39.3435 57.0914 39.6858 57.2645 40.0595 57.6631C39.0764 57.8584 38.0933 58.0557 37.1102 58.2429C36.96 58.2711 36.7992 58.261 36.6448 58.2651C34.6348 58.3335 34.4303 58.2248 33.6413 56.4189C32.915 54.758 32.6728 53.0649 33.4347 51.2913H33.4326Z",
    fill: "url(#paint4_linear_2_1703)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M46.9201 51.4644C46.1458 53.0871 45.1418 54.3795 43.8352 55.4506C43.6912 55.5694 43.4741 55.666 43.2905 55.668C41.197 55.6902 38.3041 53.6749 37.5632 51.6859C38.2603 51.2349 38.8802 51.1201 39.7422 51.5389C41.6604 52.473 43.7079 52.4046 45.745 51.8207C46.0894 51.7221 46.4317 51.6134 46.9201 51.4644Z",
    fill: "url(#paint5_linear_2_1703)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M38.5254 42.1331C37.7302 41.96 37.1812 41.6862 36.8869 40.8104C36.1981 38.7509 34.6014 37.396 32.6833 36.3672C32.4391 36.2364 32.1949 36.1075 31.9277 35.9646C32.9922 35.3546 35.8767 34.9237 37.0017 35.2016C37.1395 35.2358 37.296 35.3224 37.3774 35.4311C38.828 37.3839 39.4792 39.4897 38.6777 41.8674C38.6464 41.958 38.5796 42.0385 38.5254 42.1331Z",
    fill: "url(#paint6_linear_2_1703)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M31.0407 57.2242C29.3375 56.4854 28.0246 55.4909 26.9122 54.2447C26.8057 54.1259 26.7306 53.9286 26.7389 53.7736C26.8725 51.7201 28.6967 48.8009 30.8486 48.2493C31.335 48.9076 31.4477 49.4935 31.0156 50.3249C30.0263 52.2294 30.1557 54.2588 30.7443 56.27C30.8215 56.5317 30.905 56.7934 31.0386 57.2242H31.0407Z",
    fill: "url(#paint7_linear_2_1703)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M38.6485 46.6931C38.6589 48.1345 37.4901 49.2841 36.0061 49.2881C34.5346 49.2921 33.322 48.1224 33.3282 46.7092C33.3345 45.3261 34.5096 44.1806 35.9498 44.1483C37.4171 44.1161 38.636 45.2657 38.6464 46.6931H38.6485Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M63.2504 44.2953C63.0876 45.1248 62.6785 45.6019 61.7852 45.8918C59.6896 46.5743 58.31 48.1084 57.2518 49.9283C57.1119 50.1659 56.9909 50.4155 56.803 50.7698C56.1205 49.0989 55.8805 47.4762 56.0516 45.7952C56.0662 45.6442 56.1915 45.459 56.323 45.3664C58.3225 43.9752 60.4869 43.3592 62.9248 44.1242C63.0458 44.1624 63.1502 44.241 63.2504 44.2933V44.2953Z",
    fill: "url(#paint8_linear_2_1703)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M72.7493 49.1492C72.8912 48.2875 73.3358 47.8346 74.2186 47.5447C76.3142 46.8561 77.6855 45.318 78.7437 43.5001C78.8835 43.2625 79.0046 43.0149 79.1904 42.6666C79.8645 44.3396 80.1129 45.9683 79.9376 47.6534C79.9209 47.8044 79.7957 47.9876 79.6621 48.0782C77.6834 49.4431 75.544 50.0672 73.1291 49.3344C72.9851 49.2901 72.8578 49.2015 72.7472 49.1452L72.7493 49.1492Z",
    fill: "url(#paint9_linear_2_1703)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M73.1876 45.2556C72.672 44.5228 72.5406 43.9531 72.9622 43.1478C73.9786 41.197 73.8346 39.1274 73.2189 37.0739C73.1479 36.8383 73.0707 36.6028 72.9914 36.3531C73.8033 36.5021 74.9304 37.2712 76.1744 38.2355C77.2597 39.077 77.433 39.983 76.9237 41.1788C76.3601 42.5035 75.6317 43.6893 74.4336 44.557C74.0517 44.8349 73.6029 45.0261 73.1876 45.2536V45.2556Z",
    fill: "url(#paint10_linear_2_1703)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M62.881 48.2594C63.2629 48.9056 63.4758 49.4572 63.0396 50.2786C62.0085 52.2234 62.1588 54.297 62.7662 56.3545C62.8413 56.6102 62.9227 56.8659 63.0312 57.2263C61.3343 56.4854 60.0006 55.4848 58.8798 54.2125C58.788 54.1098 58.717 53.9427 58.7274 53.8098C58.8798 51.5329 60.9002 48.658 62.881 48.2614V48.2594Z",
    fill: "url(#paint11_linear_2_1703)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M70.5347 42.113C69.512 42.0143 69.1426 41.4667 68.8337 40.6534C68.0865 38.6784 66.5336 37.3517 64.6572 36.3572C64.4318 36.2364 64.2043 36.1156 63.9809 35.9928C63.9621 35.9827 63.958 35.9505 63.9204 35.872C65.563 35.2358 67.2641 35.0768 69.0048 35.2076C69.1363 35.2177 69.2991 35.3224 69.3805 35.4311C70.8228 37.3618 71.4469 39.4555 70.6976 41.809C70.6621 41.9217 70.5848 42.0224 70.5347 42.113Z",
    fill: "url(#paint12_linear_2_1703)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M65.4274 51.2953C66.3478 51.4725 66.8237 51.8409 67.118 52.6844C67.7817 54.593 69.2511 55.9056 71.0232 56.9102C71.355 57.0994 71.6973 57.2705 72.0647 57.6651C71.0795 57.8584 70.0944 58.0557 69.1071 58.2429C68.9297 58.2772 68.7439 58.2631 68.5623 58.2691C66.6442 58.3275 66.4376 58.2188 65.6653 56.4874C64.9139 54.8043 64.6676 53.0891 65.4295 51.2953H65.4274Z",
    fill: "url(#paint13_linear_2_1703)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M66.4104 41.7647C65.7029 42.264 65.0704 42.2861 64.2251 41.8875C62.163 40.9131 59.9965 41.0661 57.8529 41.7285C57.6567 41.7889 57.4626 41.8593 57.2643 41.9217C57.2476 41.9278 57.2226 41.9016 57.1349 41.8573C57.8738 40.289 58.9341 38.9663 60.3095 37.8731C60.4139 37.7906 60.6017 37.7604 60.7416 37.7765C63.0438 38.0483 65.611 39.5985 66.4063 41.6278C66.423 41.6701 66.4063 41.7224 66.4063 41.7667L66.4104 41.7647Z",
    fill: "url(#paint14_linear_2_1703)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M78.9065 51.4704C78.1322 53.1273 77.1032 54.4037 75.8008 55.4788C75.6609 55.5955 75.4313 55.67 75.2456 55.666C73.0665 55.6076 70.3198 53.689 69.5579 51.6838C70.2258 51.2913 70.804 51.0658 71.6577 51.4966C73.5967 52.475 75.6693 52.4046 77.7335 51.8248C78.0758 51.7281 78.416 51.6194 78.9044 51.4704H78.9065Z",
    fill: "url(#paint15_linear_2_1703)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M70.6558 46.7353C70.6475 48.1607 69.439 49.3062 67.9591 49.2861C66.4772 49.266 65.3126 48.1023 65.3376 46.6669C65.3627 45.2778 66.5503 44.1504 67.9925 44.1483C69.464 44.1483 70.6621 45.312 70.6537 46.7374L70.6558 46.7353Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2_1703",
    x1: 32.065,
    y1: 30.6395,
    x2: 47.4349,
    y2: 72.7337,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#01F68D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1C84DC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2_1703",
    x1: 32.065,
    y1: 30.6395,
    x2: 47.4349,
    y2: 72.7337,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#01F68D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1C84DC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2_1703",
    x1: 32.065,
    y1: 30.6395,
    x2: 47.4349,
    y2: 72.7337,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#01F68D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1C84DC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2_1703",
    x1: 32.065,
    y1: 30.6395,
    x2: 47.4349,
    y2: 72.7337,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#01F68D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1C84DC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2_1703",
    x1: 32.065,
    y1: 30.6395,
    x2: 47.4349,
    y2: 72.7337,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#01F68D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1C84DC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_2_1703",
    x1: 32.065,
    y1: 30.6395,
    x2: 47.4349,
    y2: 72.7337,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#01F68D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1C84DC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_2_1703",
    x1: 32.065,
    y1: 30.6395,
    x2: 47.4349,
    y2: 72.7337,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#01F68D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1C84DC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_2_1703",
    x1: 32.065,
    y1: 30.6395,
    x2: 47.4349,
    y2: 72.7337,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#01F68D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1C84DC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_2_1703",
    x1: 32.065,
    y1: 30.6395,
    x2: 47.4349,
    y2: 72.7337,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#01F68D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1C84DC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_2_1703",
    x1: 32.065,
    y1: 30.6395,
    x2: 47.4349,
    y2: 72.7337,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#01F68D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1C84DC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_2_1703",
    x1: 32.065,
    y1: 30.6395,
    x2: 47.4349,
    y2: 72.7337,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#01F68D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1C84DC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_2_1703",
    x1: 32.065,
    y1: 30.6395,
    x2: 47.4349,
    y2: 72.7337,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#01F68D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1C84DC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_2_1703",
    x1: 32.065,
    y1: 30.6395,
    x2: 47.4349,
    y2: 72.7337,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#01F68D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1C84DC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_2_1703",
    x1: 32.065,
    y1: 30.6395,
    x2: 47.4349,
    y2: 72.7337,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#01F68D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1C84DC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_2_1703",
    x1: 32.065,
    y1: 30.6395,
    x2: 47.4349,
    y2: 72.7337,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#01F68D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1C84DC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_2_1703",
    x1: 32.065,
    y1: 30.6395,
    x2: 47.4349,
    y2: 72.7337,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#01F68D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1C84DC"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGraphicsCard);
export default __webpack_public_path__ + "static/media/graphics-card.31e3bd279869920ac06c4a47cb4f00ee.svg";
export { ForwardRef as ReactComponent };